import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW6802Model } from './kymw6802.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { CodeComboBoxComponent } from '../../../commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import {
  PromotionCodeComboBoxComponent
} from '../../../commons/kymw02/combo-box/promotion-code-combo-box/promotion-code-combo-box.component';
import { ConvDivComboBoxComponent } from '../../../commons/kymw02/combo-box/conv-div-combo-box/conv-div-combo-box.component';
import { ClassCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/class-code-combo-box/class-code-combo-box.component';
import {
  LargeClassCodeComboBoxComponent
} from '../../../commons/kymw02/combo-box/large-class-code-combo-box/large-class-code-combo-box.component';
import {
  MiddleClassCodeComboBoxComponent
} from '../../../commons/kymw02/combo-box/middle-class-code-combo-box/middle-class-code-combo-box.component';
import {
  SmallClassCodeComboBoxComponent
} from '../../../commons/kymw02/combo-box/small-class-code-combo-box/small-class-code-combo-box.component';
import { VMediumTypeComboBoxComponent } from '../../../commons/kymw02/combo-box/vmedium-type-combo-box/vmedium-type-combo-box.component';
import { FeatureCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/feature-code-combo-box/feature-code-combo-box.component';
import { TagComboBoxComponent } from '../../../commons/kymw02/combo-box/tag-combo-box/tag-combo-box.component';
import { SaveCwsCategoryConvListService } from './api-services/save-cws-category-conv-list.service';
import { KYMW6802InputModel } from './vo/kymw6802-input.model';
import { SaveCWSCategoryConvListModel } from './vo/save-cws-category-conv-list.model';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';

/**
 * ECカテゴリ変換マスタ一覧表画面を管理するクラス
 *
 * @export KYMW6802Component
 * @class KYMW6802Component
 */
@Component({
  selector: 'app-kymw6802',
  templateUrl: 'kymw6802.component.html',
  styleUrls: ['kymw6802.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW6802Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw6802Model: KYMW6802Model = new KYMW6802Model();

  // 受渡し情報
  public inputVo: KYMW6802InputModel = null;

  @ViewChild('cmb_ProDiv', { static: true }) cmb_ProDiv: CodeComboBoxComponent;
  @ViewChild('cmb_ProInfo', { static: true }) cmb_ProInfo: PromotionCodeComboBoxComponent;
  @ViewChild('txti_CategoryCode', { static: true }) txti_CategoryCode: ElementRef;
  @ViewChild('rdb_Category', { static: true }) rdb_Category;
  @ViewChild('rdb_GoodsCategory', { static: true }) rdb_GoodsCategory;
  @ViewChild('rdb_PlanCategory', { static: true }) rdb_PlanCategory;
  @ViewChild('txti_MarkCode', { static: true }) txti_MarkCode: ElementRef;
  @ViewChild('txti_PageNum', { static: true }) txti_PageNum: ElementRef;
  @ViewChild('txti_ExhibitionDiv', { static: true }) txti_ExhibitionDiv: ElementRef;
  @ViewChild('cmb_ConvDiv', { static: true }) cmb_ConvDiv: ConvDivComboBoxComponent;
  @ViewChild('cmb_ClassCode', { static: true }) cmb_ClassCode: ClassCodeComboBoxComponent;
  @ViewChild('cmb_LargeClassCode', { static: true }) cmb_LargeClassCode: LargeClassCodeComboBoxComponent;
  @ViewChild('cmb_MiddleClassCode', { static: true }) cmb_MiddleClassCode: MiddleClassCodeComboBoxComponent;
  @ViewChild('cmb_SmallClassCode', { static: true }) cmb_SmallClassCode: SmallClassCodeComboBoxComponent;
  @ViewChild('cmb_PricePattern', { static: true }) cmb_PricePattern: CodeComboBoxComponent;
  @ViewChild('cmb_MediumType', { static: true }) cmb_MediumType: VMediumTypeComboBoxComponent;
  @ViewChild('cmb_FeatureCode', { static: true }) cmb_FeatureCode: FeatureCodeComboBoxComponent;
  @ViewChild('cmb_Tag1', { static: true }) cmb_Tag1: TagComboBoxComponent;
  @ViewChild('cmb_Tag2', { static: true }) cmb_Tag2: TagComboBoxComponent;


  /**
   * Creates an instance of KYMW6802Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @param {SaveCwsCategoryConvListService} saveCwsCategoryConvListService
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @memberof KYMW6802Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private saveCwsCategoryConvListService: SaveCwsCategoryConvListService,
    public fileDownloadConfirmService: FileDownloadConfirmService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW6802Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW6802';
    this.kymw6802Model.kymw6802Component = this;
    // 画面情報の初期化
    this.initKYMW6802();
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param
   * @memberof KYMW6802Component
   */
  public setInterfaceParam(param: any): void {
    this.inputVo = <KYMW6802InputModel>param;
    /** kymw6800のカテゴリ区分は0:商品マスタ、1:商品企画マスタであるのに対し、
      kymw6802のカテゴリ区分は1:商品マスタ、2:商品企画マスタであるため対応する値を格納 */
    // kymw6800のカテゴリ区分とkymw6802のカテゴリ区分を一致させたので後半をコメントアウト  
    this.kymw6802Model.categoryDiv = this.inputVo.categoryDiv;// === '0' ? '1' : '2';
    this.kymw6802Model.categoryCode = this.inputVo.categoryCode;
  }

  /**
   * 「プロモーション区分」コンボボックス変更イベント
   *
   * @memberof KYMW6802Component
   */
  public eventProDiv_CHANGEHandler(): void {

    if ('B' === this.cmb_ProDiv.selectedCodeValue) {                            // バンドルの場合
      // プロモーション情報を非活性
      this.cmb_ProInfo.disabled = true;
      this.cmb_ProInfo.setCodeValue('');
    } else {                                                                    // バンドル以外の場合
      // プロモーション情報を活性
      this.cmb_ProInfo.disabled = false;
    }
  }

  /**
   * 出力ボタンを押下した時に呼び出されるメソッド。
   *
   * @memberof KYMW6802Component
   */
  public eventCSVOut_CLICKHandler(): void {
    // 項目の重複チェック
    const chk: boolean = this.chkParam();

    if (chk) {
      const vo: SaveCWSCategoryConvListModel = this.createSaveCWSCategoryConvListVO();
      // データ取得
      this.saveCwsCategoryConvListService.execute(this.kymw6802Model, vo, (data: any) => {

        // ファイル名の設定
        const fileName = 'ECカテゴリ変換マスタ一覧表_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.tsv';

        this.fileDownloadConfirmService.show(data.FileName, fileName);
      });
    }
  }

  /**
   * パラメータチェック
   *
   * @returns {Boolean}
   * @memberof KYMW6802Component
   */
  public chkParam(): boolean {
    // タグ２
    // 重複チェック
    if (!!this.kymw6802Model.tag1 && this.kymw6802Model.tag1 === this.kymw6802Model.tag2) {
      this.dialogService.openAlertGetMessage('E0115', ['タグ２']);
      return false;
    } else {
      return true;
    }
  }

  /**
   * 画面情報の初期化
   *
   * @memberof KYMW6802Component
   */
  public initKYMW6802(): void {
    // 親画面のカテゴリ区分でラジオボタン選択
    /** kymw6800のカテゴリ区分は0:商品マスタ、1:商品企画マスタであるのに対し、
      kymw6802のカテゴリ区分は1:商品マスタ、2:商品企画マスタであるため対応する値を格納 */ 
    // kymw6800のカテゴリ区分とkymw6802のカテゴリ区分を一致させたので後半をコメントアウト  
    this.kymw6802Model.radioGroup = this.inputVo.categoryDiv; // === '0' ? '1' : '2';
    // マーク
    this.kymw6802Model.markCode = '';
    // ページ
    this.kymw6802Model.pageNum = '';
    // 催事
    this.kymw6802Model.exhibitionDiv = '';
  }

  /**
   * 検索条件のVOセット
   *
   * @returns {SaveCWSCategoryConvListModel}
   * @memberof KYMW6802Component
   */
  public createSaveCWSCategoryConvListVO(): SaveCWSCategoryConvListModel {
    const vo: SaveCWSCategoryConvListModel = new SaveCWSCategoryConvListModel();

    // カテゴリ区分
    vo.categoryDiv = String(this.kymw6802Model.radioGroup);
    // 変換区分
    vo.convDiv = PlessViewUtilsSub.nullToBlank(this.kymw6802Model.convDiv);
    // カテゴリコード
    vo.categoryCode = this.kymw6802Model.categoryCode;
    // 部門コード
    vo.classCode = PlessViewUtilsSub.nullToBlank(this.cmb_ClassCode.selectedClassCode);
    // 大分類コード
    vo.largeClassCode = PlessViewUtilsSub.nullToBlank(this.cmb_LargeClassCode.selectedLargeClassCode);
    // 中分類コード
    vo.middleClassCode = PlessViewUtilsSub.nullToBlank(this.cmb_MiddleClassCode.selectedMiddleClassCode);
    vo.smallClassCode = PlessViewUtilsSub.nullToBlank(this.cmb_SmallClassCode.selectedSmallClassCode);
    // マーク
    vo.markCode = this.kymw6802Model.markCode;
    // 価格パターン
    vo.pricePattern = PlessViewUtilsSub.nullToBlank(this.kymw6802Model.pricePattern);
    // 媒体
    vo.mediumType = PlessViewUtilsSub.nullToBlank(this.kymw6802Model.mediumType);
    // 特集
    vo.featureCode = PlessViewUtilsSub.nullToBlank(this.kymw6802Model.featureCode);
    // ページ番号
    vo.pageNum = this.kymw6802Model.pageNum;
    // プロモーション区分
    vo.promotionDiv = PlessViewUtilsSub.nullToBlank(this.kymw6802Model.proDiv);
    // プロモーション情報
    vo.promotionInfo = PlessViewUtilsSub.nullToBlank(this.kymw6802Model.proInfo);
    // 催事
    vo.exhibitionDiv = this.kymw6802Model.exhibitionDiv;
    // タグ１
    vo.tag1 = PlessViewUtilsSub.nullToBlank(this.kymw6802Model.tag1);
    // タグ２
    vo.tag2 = PlessViewUtilsSub.nullToBlank(this.kymw6802Model.tag2);

    return vo;
  }

  /**
   * 媒体変更時に呼び出されるメソッド。
   *
   * @memberof KYMW6802Component
   */
  public eventMedium_CHANGEHandler() {
    this.cmb_FeatureCode.reload(this.kymw6802Model.mediumType);
  }
}
